export default __webpack_public_path__ + "static/media/meals.6139d425.jpg";